import { useRouter } from 'next/router';
import { useActiveConversation } from '../../../chat/ActiveConversationContext';
import { PACK_HANDOFF_PARAM } from '../../../../lib/pack-handoff';

// Picking a thread from history. On Symphony the chat is a companion overlay, so
// the thread swaps in place (shallow `?conversation` on the current route) and a
// minimized chat surfaces as a panel.
export function useConversationSwitch(): (id: string | undefined, e: React.MouseEvent) => void {
  const router = useRouter();
  const { setActiveConversationId, floatChatIfMinimized } = useActiveConversation();
  return (id, e) => {
    if (!id) return;
    e.preventDefault();
    setActiveConversationId(id);
    floatChatIfMinimized();
    const query: Record<string, string | string[] | undefined> = { ...router.query, conversation: id };
    // Opening an existing thread isn't a fresh-start handoff.
    delete query.new;
    delete query.prefill;
    delete query.autosend;
    // Nor is it the pack the accept landed on, whose marker the router is still carrying
    // (see `PACK_HANDOFF_PARAM`) — a thread switch must not re-arm "Adding this pack…".
    delete query[PACK_HANDOFF_PARAM];
    const display = typeof window !== 'undefined' ? window.location.pathname : '';
    void router.replace(
      { pathname: router.pathname, query },
      `${display}?conversation=${encodeURIComponent(id)}`,
      { shallow: true },
    );
  };
}
